module.exports = __webpack_public_path__ + "img/1-3.c4c58bf2.svg";